module.exports = __webpack_public_path__ + "6d71e662962bd2f2ed734b0ceff5d9b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/two.jpg
// module id = 113
// module chunks = 0